import React from "react";
import { useParams } from "react-router-dom";
import ErrorView from "../components/ErrorView";
import LoadingScreen from "../components/LoadingScreen";
import ShowOrderView from "./ShowOrderView";
import { useOrderViewData } from "./hooks/useOrderViewData";

const ShowOrderApp = () => {
  const { id } = useParams();

  const { loading, error, order, invoiceApp, salesOrder } =
    useOrderViewData(id);

  if (loading) return <LoadingScreen text="Cargando..." />;
  if (error) return <ErrorView error={error} />;

  return (
    <ShowOrderView
      order={order}
      invoiceApp={invoiceApp}
      salesOrder={salesOrder}
    />

  );
};

export default ShowOrderApp;